import "./Hero.css";

// import required modules
import bkg from "../../assets/img/hero.jpg";
// import logobkg from "../../assets/img/LOGO en negro copia 2.png";
// import video from "../../assets/video/Video CFR.mp4";

const Hero = () => {
  return (
    <>
      <div className="hero" id="home">
        <div className="logo-container">
          <img src={bkg} alt="hero" className="logobkg" />
        </div>
      </div>
      {/* <div className="hero" id="home">
      <div
        className="hero"
        id="home"style={{ backgroundImage: `url(${bkg})` }}
        
      >
        <div className="video-container">
          <video autoPlay muted loop className="video-h">
            <source src={video} type="video/mp4" />
          </video>
        </div>
      </div> */}
    </>
  );
};

export default Hero;
